import {
  MAVRYK_GITHUB_URL,
  MAVRYK_TELEGRAM_URL,
  MAVRYK_TWITTER_URL,
  MAVRYK_DISCORD_URL,
} from 'consts/url.const';
import { pathnames } from 'routes/routes';

export type FooterNavItem = {
  title: string;
  httpLink: string;
  blank: boolean;
};

export type FooterNavigation = {
  [key: string]: FooterNavItem[];
};

// uncomment sections to test flexibility

export const footerNavigationData: FooterNavigation = {
  discover: [
    {
      title: 'Testnet',
      httpLink: `/testnet`,
      blank: false,
    },
    {
      title: 'litepaper',
      httpLink: `/litepaper`,
      blank: false,
    },
    {
      title: 'Contact Us',
      httpLink: 'mailto:info@mavryk.io?subject=Partner with Mavryk',
      blank: true,
    },
    {
      title: 'Team',
      httpLink: pathnames.TEAM,
      blank: false,
    },
    // {
    //   title: 'changelog',
    //   httpLink: defaultLink,
    // },
    // {
    //   title: 'tutorials',
    //   httpLink: defaultLink,
    // },
    // {
    //   title: 'install',
    //   httpLink: defaultLink,
    // },
    // {
    //   title: 'marketplace',
    //   httpLink: defaultLink,
    // },
  ],
  // intergrations: [
  //   {
  //     title: 'react',
  //     httpLink: defaultLink,
  //   },
  //   {
  //     title: 'vue',
  //     httpLink: defaultLink,
  //   },
  //   {
  //     title: 'threejs',
  //     httpLink: defaultLink,
  //   },
  //   {
  //     title: 'react three fiber',
  //     httpLink: defaultLink,
  //   },
  //   {
  //     title: 'webflow',
  //     httpLink: defaultLink,
  //   },
  //   {
  //     title: 'mapbox',
  //     httpLink: defaultLink,
  //   },
  // ],
  ecosystem: [
    {
      title: 'Nexus',
      httpLink: 'https://nexus.mavryk.org/',
      blank: true,
    },
    {
      title: 'Wallet',
      httpLink: pathnames.WALLET_TEASER,
      blank: false,
    },
    {
      title: 'Maven Finance',
      httpLink: 'https://mavenfinance.io/',
      blank: true,
    },
    {
      title: 'Equiteez',
      httpLink: 'https://equiteez.com/',
      blank: true,
    },
  ],
  legal: [
    // {
    //   title: 'discord',
    //   httpLink: defaultLink,
    // },
    // {
    //   title: 'forum',
    //   httpLink: defaultLink,
    // },
    // {
    //   title: 'Cookies Policy',
    //   httpLink: '#',
    // },
    {
      title: 'Privacy Policy',
      httpLink:
        'https://docs.google.com/document/d/14Op7Oij6fpBDVmw88B1DpSoTElAQIbNrGzdw1kUaRF4/edit',
      blank: true,
    },
    // {
    //   title: 'Terms of Use',
    //   httpLink: '#',
    // },
    // {
    //   title: 'youtube',
    //   httpLink: defaultLink,
    // },
    // {
    //   title: 'About',
    //   httpLink: defaultLink,
    // },
  ],
};

// uncomment sections to test flexibility
export const socialMediaData = [
  { name: 'twitter', link: MAVRYK_TWITTER_URL },
  { name: 'discord', link: MAVRYK_DISCORD_URL },
  { name: 'github', link: MAVRYK_GITHUB_URL },
  { name: 'telegram', link: MAVRYK_TELEGRAM_URL },
];
